module.exports = __webpack_public_path__ + "img/sol dark.3b6c6f9c.svg";